import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import Link from "../Link";

var SelectedGroup = function SelectedGroup(_ref) {
  var children = _ref.children,
      title = _ref.title;
  var getClassName = getClassNameFactory("SearchFiltersSelectedGroup");
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "title"
    })
  }, /*#__PURE__*/React.createElement(Link, null, title)), /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "items"
    })
  }, children));
};

SelectedGroup.displayName = "SearchFilters.SelectedGroup";
export default SelectedGroup;